import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './HowItWorks.css';

const HowItWorks = () => {
  const [activeTab, setActiveTab] = useState('professionals');

  const content = {
    institutions: {
      title: "For Institutions (B2B)",
      subtitle: "Access vetted industry experts to enhance your curriculum and provide real-world insights.",
      steps: [
        { id: 1, title: "Post an Opportunity", desc: "List your requirements for guest lectures, adjunct roles, or curriculum advisory." },
        { id: 2, title: "Review Candidates", desc: "Browse pre-vetted professionals with verified industry credentials and academic potential." },
        { id: 3, title: "Coordinate Engagement", desc: "Use our platform to schedule sessions and manage compliance documentation." },
        { id: 4, title: "Manage Payments", desc: "Securely handle professional fees through our integrated escrow system." }
      ],
      benefits: ["Access to global industry talent", "Simplified compliance & vetting", "Standardized payment processing"],
      buttonText: "Register Institution"
    },
    students: {
      title: "For Students (B2C)",
      subtitle: "Learn directly from industry leaders through personalized mentorship and career guidance sessions.",
      steps: [
        { id: 1, title: "Create Your Account", desc: "Sign up with your student email or link your university credentials. Complete your profile with your academic interests and goals." },
        { id: 2, title: "Discover Mentors", desc: "Browse hundreds of verified industry professionals across various fields. Filter by expertise, availability, ratings, and price range." },
        { id: 3, title: "Book a Session", desc: "Choose from one-on-one mentorship, portfolio reviews, mock interviews, or career guidance sessions. Select a time that works for you." },
        { id: 4, title: "Secure Payment", desc: "Pay securely through our platform. Your payment is held in escrow until the session is completed to your satisfaction." },
        { id: 5, title: "Learn & Grow", desc: "Attend your session, get personalized advice, and build valuable industry connections. Leave a review to help other students." }
      ],
      benefits: ["Direct access to industry leaders", "Flexible scheduling that fits your calendar", "Verified credentials and transparent ratings", "Secure payments with money-back guarantee"],
      buttonText: "Get Started as a Student"
    },
    professionals: {
      title: "For Professionals (Supply)",
      subtitle: "Share your expertise, mentor the next generation, and earn additional income while giving back to academia.",
      steps: [
        { id: 1, title: "Apply to Join", desc: "Submit your application with your professional background, credentials, and areas of expertise. Upload supporting documents and references." },
        { id: 2, title: "Undergo Vetting", desc: "Our expert vetting panel reviews your credentials, experience, and references. The process typically takes 5-7 business days." },
        { id: 3, title: "Build Your Profile", desc: "Once approved, create your professional profile. Set your availability, rates, and types of engagements you're interested in." },
        { id: 4, title: "Receive Opportunities", desc: "Institutions and students can discover your profile and send booking requests. Review and accept opportunities that align with your schedule." },
        { id: 5, title: "Deliver & Get Paid", desc: "Complete your engagements and receive secure payments through our escrow system. Build your reputation with positive reviews." }
      ],
      benefits: ["Flexible schedule - you control your availability", "Credibility boost through our transparent scoring system", "Secure payments with escrow protection", "Make an impact by mentoring the next generation"],
      buttonText: "Apply as a Professional"
    }
  };

  const activeData = content[activeTab];

  return (
    <div className="hiw-page-wrapper">
      <div className="hiw-container">
        {/* Back Link */}
        <Link to="/" className="hiw-back-link">
          <span className="arrow">←</span> Back to Home
        </Link>

        <div className="hiw-header">
          <h1>How It <span className="text-highlight">Works</span></h1>
          <p>Learn how our platform connects institutions, students, and professionals for meaningful academic collaborations.</p>
        </div>

        <div className="hiw-tabs">
          <button className={activeTab === 'institutions' ? 'active' : ''} onClick={() => setActiveTab('institutions')}>
            <span className="tab-icon">🏢</span> For Institutions
          </button>
          <button className={activeTab === 'students' ? 'active' : ''} onClick={() => setActiveTab('students')}>
            <span className="tab-icon">🎓</span> For Students
          </button>
          <button className={activeTab === 'professionals' ? 'active' : ''} onClick={() => setActiveTab('professionals')}>
            <span className="tab-icon">💼</span> For Professionals
          </button>
        </div>

        <div className="hiw-card">
          <h2>{activeData.title}</h2>
          <p className="hiw-card-subtitle">{activeData.subtitle}</p>

          <div className="hiw-steps">
            {activeData.steps.map((step) => (
              <div key={step.id} className="hiw-step-item">
                <div className="step-number">{step.id}</div>
                <div className="step-text">
                  <h3>{step.title}</h3>
                  <p>{step.desc}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="hiw-benefits-box">
            <h4>Key Benefits</h4>
            <ul>
              {activeData.benefits.map((benefit, idx) => (
                <li key={idx}>{benefit}</li>
              ))}
            </ul>
          </div>

          <div className="hiw-action">
            {/* Redirects to Register Page */}
            <Link to="/register" className="hiw-cta-link">
              {activeData.buttonText}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowItWorks;